import { makeRequest } from '../../../lib/api';
import {
  CreateServicePositionRequest,
  GetServicePositionsRequest,
  EditServicePositionRequest,
} from '../api/servicePositionApi';

const POSITION_PATH = '/v1/nomenclature/services';

const servicePositionController = {
  getServicePositions: (request: GetServicePositionsRequest): Promise<any> => {
    return makeRequest('get', `${ POSITION_PATH }?serviceId=${ request.serviceId }`);
  },

  createServicePosition: (request: CreateServicePositionRequest): Promise<any> => {
    return makeRequest('post', POSITION_PATH, request);
  },

  editServicePosition: (id: string, request: EditServicePositionRequest): Promise<any> => {
    return makeRequest('put', `${ POSITION_PATH }/${ id }`, request);
  },

  deleteServicePosition: (id: string): Promise<any> => {
    return makeRequest('delete', `${ POSITION_PATH }/${ id }`);
  },

};

export { servicePositionController };
